import React, { useEffect, useState, useRef } from "react";
import LogoutButton from "../Buttons/logout";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardIcon from "../../Assets/Svg/dashboard";
import ProductIcon from "../../Assets/Svg/products";
import BillingIcon from "../../Assets/Svg/billing";
import InventoryIcon from "../../Assets/Svg/inventory";
import SalesIcon from "../../Assets/Svg/sales";
import PurchaseIcon from "../../Assets/Svg/purchase";
import CustomerIcon from "../../Assets/Svg/customer";
import SalesManIcon from "../../Assets/Svg/salesmanIcon";
import SupplierIcon from "../../Assets/Svg/supplier";
import ReportIcon from "../../Assets/Svg/reports";
import ExpenseIcon from "../../Assets/Svg/expense";
import SettingIcon from "../../Assets/Svg/settings";
import ImportexpoertIcon from "../../Assets/Svg/importexport";
import AccountingIcon from "../../Assets/Svg/accouting";
import ExpandMoreIcon from "../../Assets/Svg/expand_more";
import FeatureLockWrapper from "../FeatureLocksWrapper";

const Sidebar = ({ body }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [expandedMenus, setExpandedMenus] = useState({});
  const [data, setData] = useState([]);
  const [isUnlocked, setIsUnlocked] = useState(false);

  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [selectedSubIndex, setSelectedSubIndex] = useState(-1);
  const [activeParentIndex, setActiveParentIndex] = useState(-1);
  const [isFocused, setIsFocused] = useState(false);
  const [isInSubMenu, setIsInSubMenu] = useState(false);

  const menuRefs = useRef([]);
  const subMenuRefs = useRef({});
  const sidebarRef = useRef(null);

  useEffect(() => {
    const fetchFeatureUnlocks = async () => {
      const sales = await FeatureLockWrapper.isFeatureUnlocked("wholesale_billing");
      setIsUnlocked(sales);
    };
    fetchFeatureUnlocks();
  }, []);

  useEffect(() => {
    if (!body?.role) return;
    const baseMenu = [
      { icon: <DashboardIcon />, name: "Dashboard", path: "/app/dashboard" },
      { icon: <ProductIcon />, name: "Products", path: "/app/products" },
      { icon: <ProductIcon />, name: "Services", path: "/app/services" },
      { icon: <InventoryIcon />, name: "Inventory", path: "/app/inventory" },
      { icon: <BillingIcon />, name: "Billing", path: "/app/billing" },
      ...(isUnlocked ? [{
        icon: <SalesIcon />,
        name: "Sales",
        path: "/app/sales",
      }] : []),
      { icon: <PurchaseIcon />, name: "Purchases", path: "/app/purchases" },
      { icon: <ExpenseIcon />, name: "Expenses", path: "/app/expenses" },
      { icon: <CustomerIcon />, name: "Customers", path: "/app/customers" },
      { icon: <SupplierIcon />, name: "Suppliers", path: "/app/suppliers" },
      { icon: <SalesManIcon />, name: "Salesman", path: "/app/salesman" },
      {
        icon: <AccountingIcon />,
        name: "Accounting",
        path: "/app/accounting",
        subMenu: [
          {
            name: "Chart of Accounts",
            path: "/app/accounting/chart-of-accounts",
          },
        ],
      },
      {
        icon: <ReportIcon />,
        name: "Journal Entries",
        path: "/app/manual-journals",
      },
      {
        icon: <ReportIcon />,
        name: "Financial Reports",
        path: "/app/common/reports",
      },
      { icon: <ReportIcon />, name: "Reports", path: "/app/reports" },
      {
        icon: <ImportexpoertIcon />,
        name: "Import-Export",
        path: "/app/importexport",
      },
      { icon: <SettingIcon />, name: "Settings", path: "/app/settings" },
    ];

    if (body?.role === "SUPERADMIN") {
      setData(baseMenu);
    } else {
      const allowed = [];
      const optionNames = baseMenu.map((m) => m.name);

      body?.role?.details?.forEach((perm) => {
        if (perm?.view) {
          const topLevelIdx = optionNames.indexOf(perm.name);
          if (topLevelIdx !== -1) {
            allowed.push(baseMenu[topLevelIdx]);
          } else {
            baseMenu.forEach((menu) => {
              if (menu.subMenu) {
                const subMenuItem = menu.subMenu.find(sub => sub.name === perm.name);
                if (subMenuItem) {
                  const parentExists = allowed.find(m => m.name === menu.name);
                  if (!parentExists) {
                    const filteredMenu = {
                      ...menu,
                      subMenu: menu.subMenu.filter(sub => {
                        const subPerm = body?.role?.details?.find(
                          p => p.name === sub.name && p.view === 1
                        );
                        return subPerm;
                      })
                    };
                    if (filteredMenu.subMenu.length > 0) {
                      allowed.push(filteredMenu);
                    }
                  } else {
                    const parentIdx = allowed.findIndex(m => m.name === menu.name);
                    const subPerm = body?.role?.details?.find(
                      p => p.name === perm.name && p.view === 1
                    );
                    if (subPerm && !allowed[parentIdx].subMenu.some(sub => sub.name === perm.name)) {
                      allowed[parentIdx].subMenu.push(subMenuItem);
                    }
                  }
                }
              }
            });
          }
        }
      });

      setData(allowed);
    }
  }, [body, isUnlocked]);

  const getTotalMenuItems = () => {
    let total = 0;
    data.forEach((item, index) => {
      total++;
      if (expandedMenus[item.name] && item.subMenu) {
        total += item.subMenu.length;
      }
    });
    return total;
  };

  const navigateToMenuItem = (flatIndex) => {
    let currentIndex = 0;

    for (let i = 0; i < data.length; i++) {
      if (currentIndex === flatIndex) {
        setSelectedIndex(i);
        setSelectedSubIndex(-1);
        setIsInSubMenu(false);
        if (!data[i].subMenu) {
          navigate(data[i].path);
        }
        return { parentIndex: i, subIndex: -1 };
      }
      currentIndex++;

      if (expandedMenus[data[i].name] && data[i].subMenu) {
        for (let j = 0; j < data[i].subMenu.length; j++) {
          if (currentIndex === flatIndex) {
            setSelectedIndex(i);
            setSelectedSubIndex(j);
            setIsInSubMenu(true);
            navigate(data[i].subMenu[j].path);
            return { parentIndex: i, subIndex: j };
          }
          currentIndex++;
        }
      }
    }
    return { parentIndex: -1, subIndex: -1 };
  };

  const getCurrentFlatIndex = () => {
    if (selectedIndex === -1) return -1;

    let flatIndex = 0;

    for (let i = 0; i < data.length; i++) {
      if (i === selectedIndex) {
        if (selectedSubIndex === -1) {
          return flatIndex;
        }
        flatIndex++;
        if (selectedSubIndex >= 0 && expandedMenus[data[i].name]) {
          return flatIndex + selectedSubIndex;
        }
        return flatIndex;
      }

      flatIndex++;
      if (expandedMenus[data[i].name] && data[i].subMenu) {
        flatIndex += data[i].subMenu.length;
      }
    }
    return -1;
  };

  const handleKeyDown = (e) => {
    if (!isFocused) return;

    const totalItems = getTotalMenuItems();
    const currentFlatIndex = getCurrentFlatIndex();

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        if (totalItems > 0) {
          const nextFlatIndex = currentFlatIndex < totalItems - 1 ? currentFlatIndex + 1 : 0;
          const { parentIndex, subIndex } = navigateToMenuItem(nextFlatIndex);

          setTimeout(() => {
            if (subIndex !== -1 && expandedMenus[data[parentIndex]?.name]) {
              const subMenuKey = `${parentIndex}-${subIndex}`;
              subMenuRefs.current[subMenuKey]?.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest'
              });
            } else if (parentIndex !== -1) {
              menuRefs.current[parentIndex]?.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest'
              });
            }
          }, 10);
        }
        break;

      case 'ArrowUp':
        e.preventDefault();
        if (totalItems > 0) {
          const prevFlatIndex = currentFlatIndex > 0 ? currentFlatIndex - 1 : totalItems - 1;
          const { parentIndex, subIndex } = navigateToMenuItem(prevFlatIndex);

          setTimeout(() => {
            if (subIndex !== -1 && expandedMenus[data[parentIndex]?.name]) {
              const subMenuKey = `${parentIndex}-${subIndex}`;
              subMenuRefs.current[subMenuKey]?.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest'
              });
            } else if (parentIndex !== -1) {
              menuRefs.current[parentIndex]?.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest'
              });
            }
          }, 10);
        }
        break;

      case 'ArrowRight':
        e.preventDefault();
        if (selectedIndex !== -1 && data[selectedIndex]?.subMenu && !expandedMenus[data[selectedIndex].name]) {
          toggleSubMenu(data[selectedIndex].name, e);
        } else if (selectedIndex !== -1 && expandedMenus[data[selectedIndex]?.name] && selectedSubIndex === -1) {
          const firstSubIndex = 0;
          setSelectedSubIndex(firstSubIndex);
          setIsInSubMenu(true);
          if (data[selectedIndex].subMenu[firstSubIndex]) {
            navigate(data[selectedIndex].subMenu[firstSubIndex].path);
          }

          setTimeout(() => {
            const subMenuKey = `${selectedIndex}-${firstSubIndex}`;
            subMenuRefs.current[subMenuKey]?.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest'
            });
          }, 10);
        }
        break;

      case 'ArrowLeft':
        e.preventDefault();
        if (isInSubMenu && selectedSubIndex !== -1) {
          setSelectedSubIndex(-1);
          setIsInSubMenu(false);

          setTimeout(() => {
            menuRefs.current[selectedIndex]?.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest'
            });
          }, 10);
        } else if (selectedIndex !== -1 && expandedMenus[data[selectedIndex]?.name]) {
          toggleSubMenu(data[selectedIndex].name, e);
        }
        break;

      case 'Enter':
        e.preventDefault();
        if (selectedIndex !== -1) {
          if (isInSubMenu && selectedSubIndex !== -1) {
            const subItem = data[selectedIndex]?.subMenu?.[selectedSubIndex];
            if (subItem) {
              navigate(subItem.path);
            }
          } else {
            const selectedItem = data[selectedIndex];
            if (selectedItem?.subMenu) {
              if (!expandedMenus[selectedItem.name]) {
                toggleSubMenu(selectedItem.name, e);
              }
            } else {
              navigate(selectedItem.path);
            }
          }
        }
        break;

      case 'Escape':
        e.preventDefault();
        if (isInSubMenu) {
          setSelectedSubIndex(-1);
          setIsInSubMenu(false);
        } else {
          setSelectedIndex(-1);
        }
        break;

      default:
        break;
    }
  };

  const toggleSubMenu = (name, event) => {
    if (event) {
      event.stopPropagation();
    }
    setExpandedMenus((prev) => {
      const newState = {
        ...prev,
        [name]: !prev[name],
      };

      if (!newState[name] && selectedIndex !== -1 && data[selectedIndex]?.name === name) {
        setSelectedSubIndex(-1);
        setIsInSubMenu(false);
      }

      return newState;
    });
  };

  const handleMenuClick = (value, event, index) => {
    if (event.target.closest('.expand-icon') || event.target.closest('.expand-icon-container')) {
      return;
    }

    setSelectedIndex(index);
    setSelectedSubIndex(-1);
    setIsInSubMenu(false);

    if (!value.subMenu) {
      navigate(value.path);
    } else {
      toggleSubMenu(value.name, event);
    }
  };

  const handleSubMenuClick = (parentIndex, subIndex, path) => {
    setSelectedIndex(parentIndex);
    setSelectedSubIndex(subIndex);
    setIsInSubMenu(true);
    navigate(path);
  };

  const handleMenuItemMouseEnter = (index) => {
    setSelectedIndex(index);
    setSelectedSubIndex(-1);
    setIsInSubMenu(false);
  };

  const handleSubMenuItemMouseEnter = (parentIndex, subIndex) => {
    setSelectedIndex(parentIndex);
    setSelectedSubIndex(subIndex);
    setIsInSubMenu(true);
  };

  const handleSidebarMouseLeave = () => {
    setSelectedIndex(-1);
    setSelectedSubIndex(-1);
    setIsInSubMenu(false);
  };

  const handleSidebarMouseEnter = () => {
    setIsFocused(true);
    const activeParent = data.findIndex(item =>
      isPathActive(item.path) /* location.pathname.includes(item.path) */
    );

    if (activeParent !== -1) {
      setSelectedIndex(activeParent);

      if (data[activeParent]?.subMenu) {
        const activeSub = data[activeParent].subMenu.findIndex(sub =>
          isPathActive(sub.path)   /* location.pathname.includes(sub.path) */
        );
        if (activeSub !== -1) {
          setSelectedSubIndex(activeSub);
          setIsInSubMenu(true);
        } else {
          setSelectedSubIndex(-1);
          setIsInSubMenu(false);
        }
      }
    }
  };

  const handleClickOutside = (e) => {
    if (sidebarRef.current && !sidebarRef.current.contains(e.target)) {
      setIsFocused(false);
      setSelectedIndex(-1);
      setSelectedSubIndex(-1);
      setIsInSubMenu(false);
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    document.addEventListener('mousedown', handleClickOutside);
    menuRefs.current = menuRefs.current.slice(0, data.length);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [data, selectedIndex, selectedSubIndex, expandedMenus, isInSubMenu, isFocused, navigate]);

  useEffect(() => {
    const activeParent = data.findIndex(item =>
      isPathActive(item.path) /* location.pathname.includes(item.path) */
    );

    if (activeParent !== -1) {
      setSelectedIndex(activeParent);

      if (data[activeParent]?.subMenu) {
        const activeSub = data[activeParent].subMenu.findIndex(sub =>
          isPathActive(sub.path) /* location.pathname.includes(sub.path) */
        );
        if (activeSub !== -1) {
          setSelectedSubIndex(activeSub);
          setIsInSubMenu(true);

          if (!expandedMenus[data[activeParent].name]) {
            setExpandedMenus(prev => ({
              ...prev,
              [data[activeParent].name]: true
            }));
          }
        }
      }
    }
  }, [data, location.pathname]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsFocused(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  const isPathActive = (menuPath) => {
    const current = location.pathname;

    if (current === menuPath) return true;

    return current.startsWith(menuPath + "/");
  };


  return (
    <div
      ref={sidebarRef}
      className="border-r bg-white fixed left-0 top-0 bottom-0 z-50 w-64"
      onMouseEnter={handleSidebarMouseEnter}
      onMouseLeave={handleSidebarMouseLeave}
      tabIndex={-1}
    >
      <div className="p-4 overflow-y-auto h-full">
        <div className="mt-16">
          {data.map((value, index) => {
            const isSelected = index === selectedIndex && !isInSubMenu;
            const isParentSelected = index === selectedIndex;
            const isActive = isPathActive(value.path); /* location?.pathname?.includes(value?.path); */

            return (
              <div key={index}>
                <div
                  ref={el => menuRefs.current[index] = el}
                  className={`
                    my-2 cursor-pointer rounded-lg transition-all duration-200
                    ${isActive || (isParentSelected && !isInSubMenu)
                      ? "!bg-[#6254be] !border-[#6254be]"
                      : isSelected
                        ? "bg-gray-100 border border-gray-300"
                        : "hover:bg-gray-50"
                    }
                  `}
                  onClick={(e) => handleMenuClick(value, e, index)}
                  onMouseEnter={() => handleMenuItemMouseEnter(index)}
                >
                  <div
                    className={`
                      flex p-2 items-center transition-colors duration-200
                      ${isActive || (isParentSelected && !isInSubMenu)
                        ? "text-white"
                        : isSelected
                          ? "text-[#6254be]"
                          : "text-[#353F4F] hover:text-[#6254be]"
                      }
                    `}
                  >
                    <div className={isSelected && !isActive ? "transform scale-110" : ""}>
                      {value.icon}
                    </div>
                    <div className="px-2 flex-1 font-medium">
                      {value.name}
                    </div>

                    {value.subMenu && (
                      <div
                        className="expand-icon-container"
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleSubMenu(value.name, e);
                        }}
                      >
                        <ExpandMoreIcon
                          className={`expand-icon transition-transform ${expandedMenus[value.name] ? "rotate-180" : ""
                            }`}
                        />
                      </div>
                    )}
                  </div>
                </div>

                {value.subMenu && expandedMenus[value.name] && (
                  <div className="pl-8">
                    {value.subMenu.map((sub, subIndex) => {
                      const isSubSelected = isParentSelected && subIndex === selectedSubIndex;
                      const isSubActive = isPathActive(sub.path); /* location?.pathname?.includes(sub.path); */

                      return (  
                        <div
                          key={subIndex}
                          ref={el => subMenuRefs.current[`${index}-${subIndex}`] = el}
                          className={`
                            my-2 flex items-center cursor-pointer rounded-lg transition-all duration-200
                            ${isSubActive || isSubSelected
                              ? "bg-[#6254BE] rounded-lg text-white"
                              : "text-[#353F4F] hover:text-[#6254BE] hover:bg-gray-50"
                            }
                          `}
                          onClick={() => handleSubMenuClick(index, subIndex, sub.path)}
                          onMouseEnter={() => handleSubMenuItemMouseEnter(index, subIndex)}
                        >
                          <div className="flex p-2 w-full items-center">
                            <div className="px-2 flex-1">{sub.name}</div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      <div className="w-full absolute bottom-0 left-0">
        <LogoutButton />
      </div>
    </div>
  );
};

export default Sidebar;